import { React, useState, useEffect, Card, Avatar, Toast, Breadcrumb, CustomTable, CustomModal, _formatDate, Icon, showCustomConfirmMessage, Select, useUser } from "../utils/commonImports";
import { Button, Alert, DatePicker } from "antd";
import { _api } from '../auth/Api';
import dayjs from "dayjs";
import { customStyleMd } from "../utils/common";
import { getPageRights } from "../utils/accessPages";
import { _exportToExcel } from "../helper/ExportToExcel";

const DocumentsVerify = () => {
  const [documents, setDocuments] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState({ name: "", url: "", data: {} });
  const [isLoading, setIsLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [filterBtnShow, setFilterBtnShow] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showExp, setShowExp] = useState(false);
  const { loggedInUser } = useUser();
  const userPages = loggedInUser?.roles?.[0]?.pages || [];
  const [vehiclesDrp, setVehiclesDrp] = useState([]);
  const rights = getPageRights(userPages, 13);
  const [filters, setFilters] = useState({
    customerName: "",
    email: "",
    contactNo: "",
    vehicleName: "",
    cnic: "",
    chassisNo: "",
    regNo: "",
    status: null,
    createDateFrom: null, createDateTo: null,
  });

  useEffect(() => {
    _getDocuments();
    _getVehiclesDpr()
  }, []);
  useEffect(() => {
    if (isModalOpen) {
      setIsLoading(true);
    }
  }, [isModalOpen]);
  const getExtension = (filename) => {
    return filename?.split(".").pop()?.toLowerCase();
  };

  const _getVehiclesDpr = async () => {
    try {
      await _api("GET", "Vehicle/GetDistinctVehicles", null, (res) => {
        if (res.isSuccess) {
          const List = res.data.map((v) => ({
            value: v.id,
            label: v.itemName,
          }));
          setVehiclesDrp(List);
        }
      });
    } catch (error) {
      console.log("API Error", error?.message);
    }
  };

  const _getDocuments = async (filterValues = {}, pageNo = page, numberOfRecords = pageSize) => {
    const payload = {
      customerName: filterValues.customerName || "",
      email: filterValues.email || "",
      contactNo: filterValues.contactNo || "",
      vehicleName: filterValues.vehicleName || "",
      cnic: filterValues.cnic || "",
      chassisNo: filterValues.chassisNo || "",
      regNo: filterValues.regNo || "",
      status: null,
      createDateFrom: filterValues.createDateFrom ? dayjs(filterValues.createDateFrom).format("YYYY-MM-DD") : "",
      createDateTo: filterValues.createDateTo ? dayjs(filterValues.createDateTo).format("YYYY-MM-DD") : "",
      page: {
        pageNo: pageNo,
        numberOfRecords: numberOfRecords
      }
    }
    try {
      setLoading(true);
      await _api("POST", "DocumentVerification/GetAllDocuments", payload, (res) => {
        if (res.isSuccess) {
          const tableData = dataDestructure(res.data);
          console.log("s", tableData)
          // res.data?.forEach(user => {
          //   user.documentsGroupedByVehicle?.forEach(vehicleGroup => {
          //     const vehicleRecord = {
          //       id: user.userId,
          //       vehicleId: vehicleGroup.vehicleID,
          //       vehicleName: vehicleGroup.vehicleName || "Unassigned",
          //       vehicleChassisNo: vehicleGroup.chassisNo || "---",
          //       vehicleRegNo: vehicleGroup.regNo || "---",
          //       firstName: user.firstName ?? "",
          //       lastName: user.lastName ?? "",
          //       email: user.email ?? "",
          //       contactNo: user.contactNo ?? "",
          //       cnic: user.cnic ?? "",
          //       profileImage: user.profileImage ?? "",
          //       documents: vehicleGroup.documents || [],
          //       // For verification status - sirf pehle wale doc ka status check kr rhaa hnn, bss 
          //       // isVerified: vehicleGroup.documents?.every(doc => doc.isVerified) || false
          //       isVerified: vehicleGroup.documents?.[0]?.isVerified ?? null

          //     };
          //     tableData.push(vehicleRecord);
          //   });

          //   const unassignedDocs = user.documentsGroupedByVehicle
          //     ?.filter(group => group.vehicleID === null)
          //     ?.flatMap(group => group.documents);

          //   if (unassignedDocs?.length > 0) {
          //     tableData.push({
          //       id: user.userId,
          //       vehicleId: null,
          //       vehicleName: "Unassigned",
          //       firstName: user.firstName ?? "",
          //       lastName: user.lastName ?? "",
          //       email: user.email ?? "",
          //       contactNo: user.contactNo ?? "",
          //       cnic: user.cnic ?? "",
          //       profileImage: user.profileImage ?? "",
          //       documents: unassignedDocs,
          //       isVerified: unassignedDocs.every(doc => doc.isVerified) || false
          //     });
          //   }
          // });
          setTotalRecords(res.totalRecords || 0);
          setDocuments(tableData);
        } else {
          setDocuments([])
          //Toast.fire({ icon: "error", title: res.message });
        }
      });
    } catch (error) {
      setDocuments([])
      console.error(error);
      Toast.fire({ icon: "error", title: "Failed to fetch documents" });
    } finally {
      setLoading(false)
    }
  };

  const dataDestructure = (data) => {
    const tableData = []
    if (data) {
      data?.forEach(user => {
        user.documentsGroupedByVehicle?.forEach(vehicleGroup => {
          const vehicleRecord = {
            id: user.userId,
            vehicleId: vehicleGroup.vehicleID,
            vehicleName: vehicleGroup.vehicleName || "Unassigned",
            vehicleChassisNo: vehicleGroup.chassisNo || "---",
            vehicleRegNo: vehicleGroup.regNo || "---",
            firstName: user.firstName ?? "",
            lastName: user.lastName ?? "",
            email: user.email ?? "",
            contactNo: user.contactNo ?? "",
            cnic: user.cnic ?? "",
            profileImage: user.profileImage ?? "",
            documents: vehicleGroup.documents || [],
            // For verification status - sirf pehle wale doc ka status check kr rhaa hnn, bss 
            // isVerified: vehicleGroup.documents?.every(doc => doc.isVerified) || false
            isVerified: vehicleGroup.documents?.[0]?.isVerified ?? null

          };
          tableData.push(vehicleRecord);
        });

        const unassignedDocs = user.documentsGroupedByVehicle
          ?.filter(group => group.vehicleID === null)
          ?.flatMap(group => group.documents);

        if (unassignedDocs?.length > 0) {
          tableData.push({
            id: user.userId,
            vehicleId: null,
            vehicleName: "Unassigned",
            firstName: user.firstName ?? "",
            lastName: user.lastName ?? "",
            email: user.email ?? "",
            contactNo: user.contactNo ?? "",
            cnic: user.cnic ?? "",
            profileImage: user.profileImage ?? "",
            documents: unassignedDocs,
            isVerified: unassignedDocs.every(doc => doc.isVerified) || false
          });
        }
      });
    }
    return tableData
  }

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
    _getDocuments(filters, pagination.current, pagination.pageSize);
  };

  const handleReset = () => {
    let filter = {
      customerName: "", email: "", contactNo: "", vehicleName: "", cnic: "", chassisNo: "", regNo: "", status: null, createDateFrom: null,
      createDateTo: null,
    }
    setShowExp(false)
    setFilters(filter);
    setPage(1);
    _getDocuments(filter, 1, pageSize);
  };

  const handleApply = () => {
    const { customerName, email, contactNo, vehicleName, cnic, chassisNo, regNo, status, createDateFrom, createDateTo } = filters;
    if (!customerName && !email && !contactNo && !vehicleName && !cnic && !chassisNo && !regNo && !status && !createDateFrom && !createDateTo) {
      setShowExp(true);
      return;
    }
    _getDocuments(filters, 1, pageSize);
  };

  const columns = [
    {
      title: "Customer",
      dataIndex: "firstName",
      render: (_, record) => (
        <div className="d-flex align-items-center gap-2">
          <Avatar src={record.profileImage || null}>
            {record.firstName?.charAt(0).toUpperCase()}
          </Avatar>
          <div>
            <div>{record.firstName} {record.lastName}</div>
            <div className="text-muted small"><span className="me-2">NIC: </span>{record?.cnic}</div>
          </div>
        </div>
      ),
    },
    {
      title: "Vehicle",
      dataIndex: "vehicleName",
      render: (_, record) => (
        <div style={{ lineHeight: 1.4 }}>
          <div className="">{record.vehicleName}</div>
          <div style={{ fontSize: '12px', color: '#888' }}>
            Reg No: <span style={{ color: '#10477fe3', fontWeight: "bold" }}>{record.vehicleRegNo || 'N/A'}</span> |
            Chassis No: <span style={{ color: '#10477fe3', fontWeight: "bold" }}>{record.vehicleChassisNo || 'N/A'}</span>
          </div>
        </div>
      ),
    },
    {
      title: "Contact Info",
      dataIndex: "email",
      render: (_, record) => (
        <div>
          <div className="small">{record.contactNo}</div>
          <div className="text-muted small">{record.email}</div>
        </div>
      ),
    },
    // { title: "CNIC", dataIndex: "cnic" },
    {
      title: "Documents",
      dataIndex: "documents",
      render: (_, record) => {
        return (
          <div className="d-flex flex-wrap gap-2">
            {record.documents?.map((doc, i) => {
              const ext = getExtension(doc.documentName);
              const isImage = ["jpg", "jpeg", "png"].includes(ext);
              const isPDF = ext === "pdf";

              const iconStyle = {
                fontSize: "1.4rem",
                cursor: "pointer",
                color: "#10477fa3",
              };

              const handleClick = () => {
                setSelectedDoc({
                  name: doc.documentName,
                  url: doc.imageURL,
                  data: record
                });
                setIsModalOpen(true);
              };

              return (
                <span key={i} onClick={handleClick} title={doc.documentName}>
                  {isImage && <Icon icon="mdi:image-outline" style={iconStyle} />}
                  {isPDF && <Icon icon="mdi:file-pdf-box" style={iconStyle} />}
                  {!isImage && !isPDF && <Icon icon="mdi:file-question" style={iconStyle} />}
                </span>
              );
            })}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "isVerified",
      render: (val) => {
        if (val === 2) {
          return <span className="badge bg-info">Transferred</span>;
        } else if (val === 1) {
          return <span className="badge bg-success">Approved</span>;
        } else if (val === 0) {
          return <span className="badge bg-danger">Rejected</span>;
        } else {
          return <span className="badge bg-warning">Pending</span>;
        }
      },
    },
    {
      title: "Approval",
      dataIndex: "actions",
      render: (_, record) => {
        if (record.isVerified == null) {
          return (
            <div className="d-flex gap-2">
              {rights && rights?.edit ? (<>
                <Button icon={<Icon icon="mdi:checkbox-marked-outline" />} onClick={() => _docsVerification(record, true)} />
                <Button danger icon={<Icon icon="mdi:close-box-outline" />} onClick={() => _docsVerification(record, false)} /></>
              ) : (
                <Button size="small" disabled title="Action Not Allowed">Not Allowed </Button>
              )}
            </div>
          );
        }
        return <Icon icon="mdi:file-check-outline" fontSize={20} color="green" />;
      },
    },
    // {
    //   title: "Doc's Approval",
    //   dataIndex: "action",
    //   render: (_, record) => {
    //     if (record.isVerified == null) {
    //       return (
    //         <div className="d-flex gap-2">
    //           {rights && rights?.edit ? (<>
    //             <Button icon={<Icon icon="mdi:checkbox-marked-outline" />} onClick={() => _docsVerification(record, true)} />
    //             <Button danger icon={<Icon icon="mdi:close-box-outline" />} onClick={() => _docsVerification(record, false)} /></>
    //           ) : (
    //             <Button size="small" disabled title="Action Not Allowed">Not Allowed </Button>
    //           )}
    //         </div>
    //       );
    //     }
    //     return <Icon icon="mdi:file-check-outline" fontSize={20} color="green" />;
    //   },
    // },
  ];

  const _docsVerification = async (data, status) => {
    let type = { st: status ? "Approve" : "Reject", ic: status ? "info" : "warning" }
    let isYes = await showCustomConfirmMessage({ message: `Are you sure you want to ${type.st} these documents?`, icon: `${type.ic}` }) //`${type.ic}`});
    let payload = { vehicleId: data.vehicleId, userId: data.id, isApproved: status }
    if (isYes) {
      // return
      try {
        await _api("POST", "DocumentVerification/VerifyDocuments", payload, (res) => {
          if (res.isSuccess) {
            _getDocuments();
            Toast.fire({ icon: "success", title: res?.message });
          } else {
            // Toast.fire({ icon: "error", title: res?.message });
          }
        })
      } catch (error) {
        console.log("Api Error ", error?.message)
      }
    }
  }

  const xlsColumns = [
    { title: "User Id", dataIndex: "id" },
    { title: "First Name", dataIndex: "firstName" },
    { title: "Last Name", dataIndex: "lastName" },
    { title: "Email", dataIndex: "email" },
    { title: "Contact No", dataIndex: "contactNo" },
    { title: "CNIC", dataIndex: "cnic" },
    { title: "Vehicle", dataIndex: "vehicleName" },
    { title: "Chassis No", dataIndex: "vehicleChassisNo" },
    { title: "Reg No", dataIndex: "vehicleRegNo" },
    { title: "Verified By", dataIndex: "verifiedByName" },
    // { title: "Doc Name", dataIndex: "documentName" },
    { title: "Doc Path", dataIndex: "docPath" },
    { title: "Created On", dataIndex: "createDate" },
    { title: "Status", dataIndex: "isVerified" },
  ]
  const handleExport = async () => {
    setBtnLoading(true);

    const payload = {
      customerName: "",
      email: "",
      contactNo: "",
      vehicleName: "",
      cnic: "",
      chassisNo: "",
      regNo: "",
      status: null,
      createDate: "",
      page: {
        pageNo: 0,
        numberOfRecords: 0
      }
    }

    try {
      await _api("POST", "DocumentVerification/GetAllDocuments", payload, async (res) => {
        if (res.isSuccess) {
          const tableData = await dataDestructure(res.data);

          const krDateSahe = tableData.map((x) => ({
            ...x,
            isVerified: x.isVerified === 2 ? "Transferred" : x.isVerified === 1 ? "Approved" : x.isVerified === 0 ? "Rejected" : "Pending",
            docPath: x.documents?.map(d => d.imageURL).join(" | ") || "",
            createDate: x.documents[0].createDate || "",
          }));
          setTimeout(() => {
            _exportToExcel({
              data: krDateSahe,
              columns: xlsColumns,
              fileName: "Documents Verification",
            });
            setBtnLoading(false);
          }, 1500);
        } else {
          setBtnLoading(false);
        }
      });
    } catch (error) {
      console.error(error);
      setBtnLoading(false);
    }
  };


  return (
    <>
      <Breadcrumb title="Document Verification" />
      {filterBtnShow && (
        <Card className="mb-3">
          <div className="p-2 bg-white">
            <div className="row g-2">
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Customer Name"
                  value={filters.customerName}
                  onChange={(e) =>
                    setFilters({ ...filters, customerName: e.target.value })
                  }
                />
              </div>

              <div className="col-md-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={filters.email}
                  onChange={(e) =>
                    setFilters({ ...filters, email: e.target.value })
                  }
                />
              </div>

              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Contact No"
                  value={filters.contactNo}
                  onChange={(e) =>
                    setFilters({ ...filters, contactNo: e.target.value })
                  }
                />
              </div>

              <div className="col-md-3">
                <Select
                  // options={vehicleOptions}
                  options={[
                    { label: "Alsvin", value: "alsvin" },
                    { label: "Karvaan", value: "karvaan" },
                    { label: "Oshan", value: "oshan" },
                    { label: "Sherpa", value: "sherpa" }
                  ]}
                  value={vehiclesDrp.find(opt => opt.label === filters.vehicleName) || null}
                  onChange={(val) => setFilters({ ...filters, vehicleName: val?.label || "" })}
                  placeholder="Vehicle Name"
                  isClearable
                  styles={customStyleMd}
                />
              </div>

              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="CNIC"
                  value={filters.cnic}
                  onChange={(e) =>
                    setFilters({ ...filters, cnic: e.target.value })
                  }
                />
              </div>

              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Chassis No"
                  value={filters.chassisNo}
                  onChange={(e) =>
                    setFilters({ ...filters, chassisNo: e.target.value })
                  }
                />
              </div>

              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Registration No"
                  value={filters.regNo}
                  onChange={(e) =>
                    setFilters({ ...filters, regNo: e.target.value })
                  }
                />
              </div>

              <div className="col-md-3">
                <Select
                  options={[
                    { value: null, label: "All" },
                    { value: "pending", label: "Pending" },
                    { value: "approved", label: "Approved" },
                    { value: "rejected", label: "Rejected" },
                  ]}
                  placeholder="Status"
                  value={
                    filters.status
                      ? { value: filters.status, label: filters.status }
                      : null
                  }
                  onChange={(option) =>
                    setFilters({ ...filters, status: option ? option.value : null })
                  }
                  styles={customStyleMd}
                  isClearable
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.createDateFrom ? dayjs(filters.createDateFrom) : null}
                  onChange={(date) =>
                    setFilters({ ...filters, createDateFrom: date })
                  }
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    // aaj ke baad wali date disable
                    if (current && current > dayjs().endOf("day")) return true;

                    // agar To Date select h to us se baad wali disable
                    if (filters.createDateTo) {
                      return current && current > dayjs(filters.createDateTo);
                    }
                    return false;
                  }}
                  placeholder="From Date"
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.createDateTo ? dayjs(filters.createDateTo) : null}
                  onChange={(date) =>
                    setFilters({ ...filters, createDateTo: date })
                  }
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    if (current && current > dayjs().endOf("day")) return true;
                    if (filters.createDateFrom) {
                      return current && current < dayjs(filters.createDateFrom);
                    }
                    return false;
                  }}
                  placeholder="To Date"
                />
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-between gap-2 mt-3">
              <div className="flex-grow-1">
                {showExp && (
                  <Alert
                    showIcon
                    message="NOTE: Please fill at least one filter"
                    type="warning"
                  />
                )}
              </div>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => setFilterBtnShow(false)}
                >
                  Hide Filter
                </button>
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={handleReset}
                >
                  Reset Filters
                </button>
                <button className="btn btn-sm btn-primary" onClick={handleApply}>
                  Apply Filters
                </button>
              </div>
            </div>
          </div>
        </Card>
      )}

      <Card>
        <div className="d-flex justify-content-end" style={{ marginBottom: "10px" }}>
          {!filterBtnShow && (
            <button
              onClick={() => setFilterBtnShow(true)}
              className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
              style={{ lineHeight: '1.2' }}
            >
              Filter Documents
              <Icon icon="mdi:filter-cog-outline" className="text-md" />
            </button>
          )}
          <button
            onClick={handleExport}
            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
            style={{ lineHeight: '1.2' }}
            disabled={btnLoading}
          >
            {btnLoading && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            {btnLoading ? "Exporting..." : "Export to Excel"}
            <Icon icon="mdi:microsoft-excel" className="text-md" />
          </button>
        </div>
        <CustomTable
          columns={columns}
          dataSource={documents}
          options={{
            withActions: false,
            loading: loading,
            bordered: true,
            size: "small",
            rowKey: "docVerificationId",
            emptyText: "No documents found",
            pageKey: 13
          }}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: totalRecords,
            showSizeChanger: true,
            currentLength: documents.length
          }}
          onChange={handleTableChange}
        />
        <CustomModal show={isModalOpen} size="lg" onHide={() => setIsModalOpen(false)} title={selectedDoc.name}>
          <div style={{ position: "relative", minHeight: "200px" }}>
            {isLoading && (
              <div className="d-flex justify-content-center align-items-center"
                style={{ position: "absolute", inset: 0, zIndex: 10, backgroundColor: "rgba(255, 255, 255, 0.7)" }}
              >
                <div class="spinner-border custom-spinner" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            )}
            <div className="d-flex justify-content-between align-items-center border p-3 rounded bg-light mb-3">
              <span className="text-sm">Vehicle: <span className="fw-semibold mb-0" style={{ color: "#124880" }}>{selectedDoc?.data?.vehicleName}</span></span>
              <span className="text-sm">Chassis No: <span className="fw-semibold mb-0" style={{ color: "#124880" }}>{selectedDoc?.data?.vehicleChassisNo}</span></span>
              <span className="text-sm">Reg No: <span className="fw-semibold mb-0" style={{ color: "#124880" }}>{selectedDoc?.data?.vehicleRegNo}</span></span>
            </div>

            {(() => {
              const ext = getExtension(selectedDoc.url);
              if (["jpg", "jpeg", "png"].includes(ext)) {
                return (
                  <img
                    src={selectedDoc.url}
                    alt="Document"
                    style={{ width: "100%", display: isLoading ? "none" : "block" }}
                    onLoad={() => setIsLoading(false)}
                    onError={() => setIsLoading(false)}
                  />
                );
              } else if (ext === "pdf") {
                return (
                  <iframe
                    src={selectedDoc.url}
                    title="PDF Document"
                    style={{ width: "100%", height: "500px", border: "none", display: isLoading ? "none" : "block" }}
                    onLoad={() => setIsLoading(false)}
                  />
                );
              } else {
                return <p>Unsupported file type</p>;
              }
            })()}
          </div>
        </CustomModal>

      </Card>
    </>
  );
};

export default DocumentsVerify;